<template>
  <div
    id="popupimage"
    class="popup-image"
  >
    <div class="popup-image__content">
      <div class="popup-image__left u-hidden-tab-land">
        <img
          :src="image"
          alt="Tour photo"
          class="popup-image__img"
        >
      </div>
      <div class="popup-image__right">
        <a
          href="#section-projects"
          class="popup-image__close"
        >&times;</a>
        <h2 class="heading-secondary u-margin-bottom-small">
          Image Details
        </h2>
        <h3 class="heading-tertiary u-margin-bottom-small">
          {{ resolvedFileName(image) }}
        </h3>
        <p class="popup-image__text">
          <ul>
            <li>Extension: {{ resolvedExtension(image) }}</li>
            <li>Available Resolutions (Opens new window)</li>
            <ul>
              <li>
                <a
                  :href="resolvedImage100(image)"
                  target="_blank"
                  class=""
                >100px</a>
              </li>
              <li>
                <a
                  :href="resolvedImage720(image)"
                  target="_blank"
                  class=""
                >720px </a>
              </li>
              <li>
                <a
                  :href="resolvedImage1920(image)"
                  target="_blank"
                  class=""
                >1920px</a>
              </li>
            </ul>
          </ul>  
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/eventbus/event-bus';
export default {
  
  name: 'PopupImage',
  data: function () {
    
    return {
      image: "",
      dataLoaded: false
    }
    
  },
  mounted() {
     EventBus.$on('popupImageSelected', (name) => {
     this.image = name
    });
},
   methods: {
      onClickChild (value) {
      console.log(value) // someValue
    },
    resolvedImage100 (path){
      var filename = path.replace('@s_720', '@s_100')
      return filename
    },
     resolvedImage720 (path){
      var filename = path.replace('@s_720', '@s_720')
      return filename
    },
     resolvedImage1920 (path){
      var filename = path.replace('@s_720', '@s_1920')
      return filename
    },


    resolvedFileName(path)  {
      var filename = path.replace(/^.*[\\\/]/, '')
      filename = filename.replace('@s_720', '')
      var extension = path.split('.').pop();
      return filename
    },
     resolvedExtension(path)  {
      var extension = path.split('.').pop();
      return extension
    }
   }
}
</script>
